import { useEffect, useState } from 'react'
import {
  SIDEBAR_DRAWER_WIDTH,
  isAnySidebarOpen,
  subscribeSidebarUrlChange
} from '../utils/sidebarUrl'

export function useSidebarLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(() => isAnySidebarOpen())

  useEffect(() => {
    const sync = () => setSidebarOpen(isAnySidebarOpen())
    sync()
    return subscribeSidebarUrlChange(sync)
  }, [])

  return {
    sidebarOpen,
    sidebarWidth: sidebarOpen ? SIDEBAR_DRAWER_WIDTH : 0,
    drawerWidth: SIDEBAR_DRAWER_WIDTH
  }
}
